import React from 'react';

export default ({handleClick, activePage, className, allRowsCount, selectedRowsCount}) => {
  const lastPage = +selectedRowsCount ? Math.ceil(allRowsCount / selectedRowsCount) : 1;
  const firstButtonClasses = activePage === 1 ? 'ect-pagination_disabled' : '';
  const lastButtonClasses = activePage === lastPage ? 'ect-pagination_disabled' : '';

  function getPaginationNumbers() {
    const from = activePage - 2;
    const to = activePage + 2;

    if (lastPage < 6) return printNumbers(1, lastPage);
    if (from < 1) return printNumbers(1, 5);
    if (to > lastPage) return printNumbers(lastPage - 4, lastPage);
    return printNumbers(from, to);

    function printNumbers(from, to) {
      const numbers = [];
      const numberElement = (number, active) => (
        <div key={number} className={`ect-pagination__number ${active ? 'active' : ''}`} onClick={handleNumberClick(number)}>{number}</div>);

      for (let i = from; i <= to; i++) {
        const isActive = +activePage === i;
        numbers.push(numberElement(i, isActive));
      }

      return numbers;
    }
  }

  function handleFirstClick() {
    handleClick(1);
  }

  function handleLastClick() {
    handleClick(lastPage);
  }

  function handleNextClick() {
    const nextPage = activePage + 1;
    if (nextPage <= lastPage) handleClick(nextPage);
  }

  function handlePrevClick() {
    const prevPage = activePage - 1;
    if (prevPage > 0) handleClick(prevPage);
  }

  function handleNumberClick(number) {
    return () => {
      handleClick(number);
    };
  }

  if (lastPage < 2) return null;
  if (lastPage === null) return null;

  return (
    <section className={`ect-pagination ${className}`}>
      <div onClick={handleFirstClick} className={`ect-pagination__first ${firstButtonClasses}`}>First</div>
      <div onClick={handlePrevClick} className={`ect-pagination__first ${firstButtonClasses}`}>{'<'}</div>
      {getPaginationNumbers()}
      <div onClick={handleNextClick} className={`ect-pagination__last ${lastButtonClasses}`}>{'>'}</div>
      <div onClick={handleLastClick} className={`ect-pagination__last ${lastButtonClasses}`}>Last</div>
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/app/Components/Pagination.jsx